import { TreeNode } from '../models/common/tree-node.model';

export const buildTreeFrom = <T>(
  items: T[],
  mapFn: (item: T) => Omit<TreeNode, 'children'>,
  sortFn?: (a: TreeNode, b: TreeNode) => number
): TreeNode[] => {
  const lookup = new Map<string, TreeNode>(
    items.map((item) => {
      const data: TreeNode = {
        ...mapFn(item),
        children: [],
      };

      return [data.id, data];
    })
  );

  const roots = Array.from(lookup.values()).reduce<TreeNode[]>((roots, node) => {
    const parentNode = node.parentId ? lookup.get(node.parentId) : null;

    if (parentNode) {
      parentNode.children = [...parentNode.children, node];

      return roots;
    }

    return [...roots, node];
  }, []);

  const sortTree = (nodes: TreeNode[]) => {
    nodes.sort(sortFn);
    nodes.forEach((node) => sortTree(node.children));
  };

  if (sortFn) {
    sortTree(roots);
  }

  return roots;
};
